// Testimonials.jsx
import React from 'react';
import CardTestimonials from './cardTestimonials';
import './testimonials.css';

export default function Testimonials() {
    const testimonialsData = [
        { rating: 5, text: "Paycott's offer creation process is easy and intuitive, and the buyer acceptance feature ensures that we only receive payment once the buyer approves the work. A truly innovative solution!", author: "Sarah Thompson" },
        { rating: 5, text: "Paycott's platform has revolutionised our online business. We now have complete confidence in our transactions and have seen a significant increase in sales.", author: "John Carter" },
        { rating: 5, text: "We were hesitant to engage in online commerce until we discovered Paycott. Their secure payment system and buyer acceptance feature have made all the difference for our business.", author: "Emma Rodriguez" },
        { rating: 5, text: "Paycott's platform is the future of online transactions. Their commitment to secure and transparent transactions has earned our trust and loyalty.", author: "David Wilson" }
    ];

    return (
        <div className="w-full my-10 sm:px-0 flex flex-col items-center justify-center pb-20  overflow-x-hidden">
            <span className="flex flex-col font-pop text-lg justify-center items-center px-3 py-1 mb-4 bg-white rounded-lg text-gray-700 mx-auto w-fit">CLIENT TESTIMONIALS</span>
            <p className="inline-block px-3 py-1 mb-4 text-black font-pop text-base md:text-lg font-semibold overflow-hidden">Hear what our clients have to say about us</p>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 w-[95%] xl:w-[90%]  mx-auto overflow-hidden">
                <div className="testimonial-slider mobile">
                    {testimonialsData.map((testimonial, index) => (
                        <div key={index} className="testimonial-item mobile w-80 h-auto">
                            <CardTestimonials rating={testimonial.rating} text={testimonial.text} author={testimonial.author} />
                        </div>
                    ))}
                </div>
                {testimonialsData.map((testimonial, index) => (
                    <div key={index} className="desktop-only h-auto">
                        <CardTestimonials rating={testimonial.rating} text={testimonial.text} author={testimonial.author} />
                    </div>
                ))}
            </div>
        </div>
    );
}
